commaRoundTrip